import { mapGetters } from "vuex";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import updateFirebase from "@/data/cloud/firebase/mixins/updateFirebase.js";
import deleteFirebase from "@/data/cloud/firebase/mixins/deleteFirebase.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import changeFirebase from "@/data/cloud/firebase/mixins/changeFirebase.js";
import docLogFunctions from "@/document/log/mixins/docLogFunctions.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import announcements from "@/frame/messages/mixins/announcements.js";

export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [
    announcements,
    dataSources,
    createFirebase,
    updateFirebase,
    deleteFirebase,
    changeFirebase,
    docLogFunctions,
    storeFunctions
  ],
  computed: {
    ...mapGetters([
      "getDetail",
      "getDetailSelect",
      "getTransitions",
      "getDocumentLog"
    ])
  },
  methods: {
    authDetail() {
      // u updated data that you want to send
      if (this.getDetail !== null) {
        this.btnSpinChangeDetail = true;

        // DEFINE
        let temp = this.getDetail; // this can by anything Z5 / F1 /
        const tag = temp.basic.tag; // "G1"
        const did = temp.basic.did; // "Common"

        // UPDATE TRANS
        if (this.getTransitions !== undefined && this.getTransitions !== null) {
          temp.trans = this.getTransitions;
        }
        // UPDATE SELECT
        // eslint-disable-next-line
        if (this.getDetailSelect !== undefined && this.getDetailSelect !== null) {
          temp.select = this.getDetailSelect;
        }

        // UPDATE CLOUD
        if (tag === "G1") {
          // dependiing on access result different ouctomes are expected
          let level = temp.trans.level;
          let hold = temp.trans.stat.hold;
          let agree = temp.trans.flow[temp.trans.flow.length - 1].agree;
          let lock = temp.trans.stat.lock;
          let progress = temp.trans.stat.progress;
          let tags = temp.basic.tags; // source tag
          let tagd = temp.basic.tagd; // desnitaion
          let dbsFacilityUser = null;
          let dbsCompanyUser = null;
          let dbsAdminAccess = null; // dest
          // let dbsUserAccess = null;
          let dbsCompany = null;
          let dbsFacility = null;

          // ASSIGN DBS
          if (tags === "C1" || tagd === "C1") {
            // eslint-disable-next-line
            // dbsUserAccess = this.defineDataSourceFromTagForRelationship(tag, "U1");
            // eslint-disable-next-line
            dbsAdminAccess = this.defineDataSourceFromTagForRelationship(tag, "Z5");
            // eslint-disable-next-line
            dbsCompanyUser = this.defineDataSourceFromTagForRelationship(tag, "C1");
            // eslint-disable-next-line
            dbsCompany = this.defineDataSourceFromTag("C1");
            // download C1 (user for statss update)
            let cdid = temp.select.cdid;
            this.$store.dispatch("changeCompanyDID", cdid);
            this.getDocumentCompanyOnly(cdid);
          } else {
            let fdid = temp.select.fdid;
            let cdid = temp.select.cdid;
            this.$store.dispatch("changeCompanyDID", cdid);
            this.$store.dispatch("changeFacilityDID", fdid);
            this.getDocumentCompanyOnly(cdid);
            this.getDocumentCompanyOnly(fdid);
            // eslint-disable-next-line
            dbsFacilityUser = this.defineDataSourceFromTagForRelationship(tag, "F1");
            // eslint-disable-next-line
            dbsFacility = this.defineDataSourceFromTag("F1");
          }

          // REQUEST MORE INFO
          if (level === 1 && hold !== null) {
            if (tagd === "U1" && tags === "C1") {
              // USER ACCESS update
              this.updateUserCompanyAccess(temp);
              // Update ADMIN or COMPANY ADMIN
              if (temp.select.cauth === 0) {
                temp.basic.tagd = "Z5";
                temp.basic.tags = "C1";
                this.updateFirebaseDocumentDirect(dbsAdminAccess, did, temp);
              } else {
                this.updateCompanyUserAccess(temp);
              }
              this.$router.push("/userdash");
            }
            if (tagd === "C1" && tags === "U1") {
              // USER Log update
              this.updateUserCompanyAccess(temp);
              // COMPANY User update
              this.updateCompanyUserAccess(temp);
              // router
              this.$router.push("/companydash");
            }
            if (tagd === "Z5" && tags === "C1") {
              // ADMIN update for new Company
              // eslint-disable-next-line
              this.updateFirebaseDocumentDirect(dbsAdminAccess, did, temp);
              // USER ACCESS for Company for
              this.updateUserCompanyAccess(temp);
              // router
              this.$router.push("/admindash");
            }
            if (tagd === "U1" && tags === "F1") {
              // USER ACCESS update
              this.updateUserFacilityAccess(temp);
              // Update FACILITY USER
              this.updateFacilityUserAccess(temp);
              this.$router.push("/userdash");
            }
            if (tagd === "F1" && tags === "U1") {
              // USER ACCESS update
              // eslint-disable-next-line
              this.generateLog("U1", "Facility Access", "more info was requested.", temp);
              this.updateUserFacilityAccess(temp);
              // Update FACILITY USER
              this.updateFacilityUserAccess(temp);
              this.$router.push("/facilitydash");
            }
            // LOCK USER
          } else if (level > 1 && lock === true && progress === false) {
            // console.log("LOCK");
            // console.log("");
            if (tagd === "C1" && tags === "U1") {
              // USER ACCESS update
              this.generateLog("C1", "Company Access", "was locked.", temp);
              this.updateUserCompanyAccess(temp);
              // COMPANY User update
              this.generateLog("U1", "User Access", "was locked.", temp);
              this.updateCompanyUserAccess(temp);
              // router
              this.$router.push("/companydash");
            }
            if (tagd === "F1" && tags === "U1") {
              // console.log("LOCK USER");
              // USER ACCESS update
              this.generateLog("U1", "Facility Access", "was locked.", temp);
              this.updateUserFacilityAccess(temp);
              // Update FACILITY USER
              this.generateLog("F1", "User Access", "was locked.", temp);
              this.updateFacilityUserAccess(temp);
              // Reset USER
              let db = this.defineDataSourceFromTag("U1");
              let didUser = temp.char.udid;
              this.changeFirebaseDocumentUserPrefSelectReset(db, didUser);
              this.$router.push("/facilitydash");
            }
            // MORE INFO PROVIDED
            // eslint-disable-next-line
          } else if (level > 1 && lock === false && progress === false) {
            // console.log("LOCK");
            // console.log("");
            if (tagd === "C1" && tags === "U1") {
              // USER ACCESS update
              this.generateLog("C1", "Company Access", "was unlocked.", temp);
              this.updateUserCompanyAccess(temp);
              // COMPANY User update
              this.generateLog("U1", "User Access", "was unlocked.", temp);
              this.updateCompanyUserAccess(temp);
              // router
              this.$router.push("/companydash");
            }
            if (tagd === "F1" && tags === "U1") {
              // console.log("LOCK USER");
              // USER ACCESS update
              this.generateLog("U1", "Facility Access", "was unlocked.", temp);
              this.updateUserFacilityAccess(temp);
              // Update FACILITY USER
              this.generateLog("F1", "User Access", "was unlocked.", temp);
              this.updateFacilityUserAccess(temp);
              // Reset USER
              let db = this.defineDataSourceFromTag("U1");
              let didUser = temp.char.udid;
              this.changeFirebaseDocumentUserPrefSelectReset(db, didUser);
              this.$router.push("/facilitydash");
            }
            // MORE INFO PROVIDED
            // eslint-disable-next-line
          } else if (level > 1 && agree === false && lock === false && progress === true) {
            // REJECT COMPANY REQUEST
            console.log("");
            console.log(">>> REJECT ACCESS <<<");
            if (tagd === "Z5" && tags === "C1") {
              // USER access delete
              let udid = temp.char.udid;
              this.deleteFirebaseDocumentUserAccess(udid, temp);
              // COMP ADMIN delete
              if (temp.select.cauth > 0 || temp.select.cauth === null) {
                // eslint-disable-next-line
                this.deleteFirebaseDocumentDirect(dbsCompanyUser, temp);
              }
              // ADMIN New Company Delete access and company
              if (temp.select.cauth === 0) {
                // eslint-disable-next-line
                this.deleteFirebaseDocumentDirect(dbsAdminAccess, temp);
                // temp is access
                temp.basic.did = temp.select.cdid;
                this.deleteFirebaseDocumentDirect(dbsCompany, temp);
                // USER Log
                let udid = temp.char.udid;
                this.$store.dispatch("changeUserDID", udid);
                let title = "New Company Request ";
                let log = this.generateLog("U1", title, "was rejected.", temp);
                this.createFirebaseDocumentLog("U1", log);
                // SNACKBAR
                let msg = "New Company Request ";
                msg = msg + temp.char.title + " was rejected.";
                this.generateInfoSnackbar(this.ui.colorBlue1, msg);
                // go to router
                this.$router.push("/admindash");
              }
            }
            if (tagd === "C1" && tags === "U1") {
              // USER access delete
              let udid = temp.char.udid;
              this.deleteFirebaseDocumentUserAccess(udid, temp);
              this.deleteFirebaseDocumentDirect(dbsCompanyUser, temp);
              // USER Log
              // eslint-disable-next-line
              let log = this.generateLog("U1", "Company Access", "was rejected.", temp);
              this.$store.dispatch("changeUserDID", udid);
              this.createFirebaseDocumentLog("U1", log);
              // SNACKBAR
              let msg = "Company Access ";
              msg = msg + temp.char.title + " was rejected.";
              this.generateInfoSnackbar(this.ui.colorBlue1, msg);
              // Reset Store
              // this.resetCompanyFacilityStore();
              // router
              this.$router.push("/companydash");
            }
            if (tagd === "F1" || tags === "F1") {
              // USER access delete
              let udid = temp.char.udid;
              this.deleteFirebaseDocumentUserAccess(udid, temp);
              // Facility User access delete
              this.deleteFirebaseDocumentDirect(dbsFacilityUser, temp);
              // SPECIAL - facility delete
              if (temp.select.fauth === 0) {
                // eslint-disable-next-line
                // temp is access
                temp.basic.did = temp.select.fdid;
                this.deleteFirebaseDocumentDirect(dbsFacility, temp);
                // Reset Store
                this.resetCompanyFacilityStore();
                // go to router
                this.$router.push("/userdash");
              }
              // USER Log
              // eslint-disable-next-line
              let log = this.generateLog("U1", "Facility Access", "was rejected.", temp);
              this.$store.dispatch("changeUserDID", udid);
              this.createFirebaseDocumentLog("U1", log);
              // SNACKBAR
              let msg = "Facility Access ";
              msg = msg + temp.char.title + " was rejected.";
              this.generateInfoSnackbar(this.ui.colorBlue1, msg);
            }

            // APPROVE ACCESS
            // eslint-disable-next-line
          } else if (level > 1 && agree === true && lock === false && progress === true) {
            // APPROVE COMPANY ACCESS
            if (tagd === "C1" || tagd === "Z5") {
              console.log("");
              console.log(">>>  APPROVE COMPANY  <<<");
              // USER ACCESS for Company
              this.updateUserCompanyAccess(temp);
              // COMPANY USER CREATE / UPDATE
              this.updateCompanyUserAccess(temp);
              // // NEW USER COMPANY stats
              if (temp.select.cauth !== 0) {
                if (
                  temp.trans.stat.new === true &&
                  temp.trans.stat.active === true
                ) {
                  console.log("ADD COMP USER");
                  let cdid = temp.char.did;
                  this.changeFirebaseStatsRemote("C1", cdid, "nu1", 1, true);
                }
              }
              // EXTRA if NEW COMPANY was created
              if (temp.select.cauth === 0) {
                // DELETE ADMIN access as the company was approved
                this.deleteFirebaseDocumentDirect(dbsAdminAccess, temp);
                // COMPANY activated and add access key
                let db = this.defineDataSourceFromTag(tags);
                let didComp = temp.select.cdid;
                this.changeFirebaseDocumentBasicAct(db, didComp, true);

                // Reset Store
                this.resetCompanyFacilityStore();
                // router
                this.$router.push("/admindash");
              } else {
                // Reset Store
                // this.resetCompanyFacilityStore();
                this.$router.push("/companydash");
              }
            }
            // APPROVE FACILITY ACCSSS
            if (tagd === "F1" || tags === "F1") {
              console.log("");
              console.log(">>> FACILITY ACCESS <<<");
              console.log(temp);
              // FACILITY USER CREATE / UPDATE
              let fdid = temp.select.fdid;
              let cdid = temp.select.cdid;
              this.$store.dispatch("changeCompanyDID", cdid);
              this.$store.dispatch("changeFacilityDID", fdid);

              // UPDATE FACILITY STATS (NEW USER ONLY)
              if (
                temp.trans.stat.new === true &&
                temp.trans.stat.active === true
              ) {
                let facilityDID = temp.char.did;
                // eslint-disable-next-line
                this.changeFirebaseStatsRemote("F1", facilityDID, "nu1", 1, true);
              }

              // New Facility User ADD
              this.updateFacilityUserAccess(temp);

              // NEW USER Facility Access ADD/UPDATE
              this.updateUserFacilityAccess(temp);

              // Reset Store
              // this.resetCompanyFacilityStore();

              // Return to Facility Access List
              this.$router.push("/userdash");
            }
          } else {
            // do nothing
          }
          // eslint-disable-next-line
          this.$store.dispatch("changeDataSavePendingIndication", false);
          this.btnSpinChangeDetail = false;
        }
      }
    },
    updateCompanyUserAccess(access) {
      const did = access.basic.did; // "Common"
      let auth = access.select.cauth; // originator / requestor
      let temp = access;
      let db = this.defineDataSourceFromTagForRelationship("G1", "C1");
      temp.basic.tagd = "C1";
      temp.basic.tags = "U1";
      // CHANGE USER LOG
      let title = "User Access Level " + auth + " for ";
      let log = this.generateLog("C1", title, "was updated.", temp);
      let cdid = temp.char.did;
      this.$store.dispatch("changeCompanyDID", cdid);
      this.createFirebaseDocumentLog("C1", log);
      // UPDATE ACCESS
      this.updateFirebaseDocumentDirect(db, did, temp);
    },
    updateFacilityUserAccess(access) {
      const did = access.basic.did; // "Common"
      let temp = access;
      let auth = access.select.fauth; // originator / requestor
      let db = this.defineDataSourceFromTagForRelationship("G1", "F1");
      temp.basic.tagd = "F1";
      temp.basic.tags = "U1";
      // LOG
      let fdid = temp.char.did;
      let title = "User Access Level " + auth + " for ";
      let log = this.generateLog("F1", title, "was updated.", temp);
      this.$store.dispatch("changeFacilityDID", fdid);
      this.createFirebaseDocumentLog("F1", log);
      // UPDATE ACCESS
      this.updateFirebaseDocumentDirect(db, did, temp);
    },
    updateUserCompanyAccess(access) {
      let udid = access.char.udid; // originator / requestor
      let auth = access.select.cauth; // originator / requestor
      let temp = access;
      temp.basic.tagd = "U1"; // user
      temp.basic.tags = "C1"; // company
      // CHANGE USER LOG
      this.$store.dispatch("changeUserDID", udid);
      // eslint-disable-next-line
      let title = "Company Access Level " + auth + "";
      if (access.basic.lock === true) {
        title = title + " is Locked for ";
      }
      if (access.basic.lock === false) {
        title = title + " is Active for ";
      }
      // title = title + " " + access.char.title + " ";
      let log = this.generateLog("U1", title, "was updated.", temp);
      this.createFirebaseDocumentLog("U1", log);
      // CHANGE ACCESS
      this.updateFirebaseDocumentUserAccess(udid, temp);
    },
    updateUserFacilityAccess(access) {
      let udid = access.char.udid; // originator / requestor
      let auth = access.select.fauth; // originator / requestor
      let temp = access;
      temp.basic.tagd = "U1"; // user
      temp.basic.tags = "F1"; // company
      console.log("UPDATE USER FACILITY ACCESS");
      console.log(temp);
      console.log(this.getDocumentLog);
      this.$store.dispatch("changeUserDID", udid);
      // eslint-disable-next-line
      let title = "Facility Access Level " + auth + "";
      if (access.basic.lock === true) {
        title = title + " is Locked for ";
      }
      if (access.basic.lock === false) {
        title = title + " is Active for";
      }
      // title = title + " " + access.char.title + " ";
      let log = this.generateLog("U1", title, "was updated.", temp);
      this.createFirebaseDocumentLog("U1", log);
      this.updateFirebaseDocumentUserAccess(udid, temp);
    }
  }
};
